import e from "../../hooks/usePrevious.js";
import t from "../../utils/classNames.js";
import n from "../../hooks/useMergeRefs.js";
import { forwardRef as r, useRef as i, useState as a } from "react";
import { noop as o } from "es-toolkit/function";
import { isEmpty as s, omit as c } from "es-toolkit/compat";
import { isFunction as l, isNil as ee } from "es-toolkit/predicate";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
import { IMaskInput as f } from "react-imask";
//#region src/components/clearableInput/ClearableInput.tsx
var p = "text", m = [
	"text",
	"password",
	"email"
], h = (e) => !s(`${e}`), g = r((r, s) => {
	let { type: g = p, defaultValue: _, value: v, showClearButton: y = !0, maxLength: b, tabIndex: x = 0, hasError: S = !1, inputRef: C, autoComplete: w, onChange: T = o, onBlur: E = o, onFocus: te = o, onClear: D = o, onKeyPress: ne = o, onClick: re = o, mask: O, maskPlaceholder: ie = "_", maskVisibility: k = "always", maskOverwrite: A = !0, maskDefinitions: j, maskDispatch: M, inputClassName: N = "", disabled: P = !1, readOnly: F = !1, className: I = "", children: L, ...R } = r, z = v || _ || "", [B, V] = a(z), [H, U] = a(h(z)), [W, G] = a(!1), K = !ee(v), q = i(null), J = n(q, C, s), Y = !!O, ae = () => {
		switch (k) {
			case "always": return !0;
			case "onFocus": return W;
			case "never": return !1;
			default: return W;
		}
	}, X = (e = "") => {
		B !== e && (V(e), U(h(e)));
	};
	e(v) !== v && X(v);
	let oe = (e) => {
		let t = e.target.value;
		K || X(t), T(t, e);
	}, se = (e, t, n) => {
		if (!q.current) return;
		let r = {
			target: q.current,
			currentTarget: q.current,
			bubbles: !0,
			cancelable: !0,
			defaultPrevented: !1,
			isTrusted: !0,
			preventDefault: () => {},
			stopPropagation: () => {},
			persist: () => {},
			nativeEvent: {},
			type: "change",
			timeStamp: Date.now()
		};
		r.target.unmaskedValue = t.unmaskedValue, K || X(e), T(e, r);
	}, ce = (e) => {
		G(!0), te(e);
	}, le = (e) => {
		G(!1), E(e);
	}, ue = (e) => {
		ne(e);
	}, de = (e) => {
		X(""), T("", e), D && D(e);
	}, fe = t("ClearableInput", "input-group", S && "has-error", P && "pointer-events-none", I && I), pe = t("form-control", N, H && y && "withClearButton", Y && "withInputMask", P && "disabled"), me = t("clearButton", (!H || !y) && "hide"), Z = g?.toLowerCase(), he = m.indexOf(Z) === -1 ? p : Z, Q = {
		...c(R, [
			"value",
			"defaultValue",
			"onClear"
		]),
		className: pe,
		autoComplete: w,
		type: he,
		value: B,
		onKeyPress: ue,
		onBlur: le,
		onFocus: ce,
		onChange: Y ? void 0 : oe,
		onClick: re,
		disabled: P,
		readOnly: F,
		maxLength: Y ? void 0 : b,
		tabIndex: x
	}, $ = {};
	M && ($.dispatch = M);
	let ge = Y ? /* @__PURE__ */ u(f, {
		...Q,
		inputRef: J,
		mask: O,
		definitions: j,
		...$,
		placeholderChar: ie,
		onAccept: se,
		lazy: !ae(),
		overwrite: A
	}) : /* @__PURE__ */ u("input", {
		...Q,
		ref: C || s
	});
	return /* @__PURE__ */ d("div", {
		className: fe,
		children: [L && l(L) ? L(Q) : ge, /* @__PURE__ */ u("span", {
			className: me,
			onClick: de,
			children: /* @__PURE__ */ u("span", { className: "clearButtonIcon uikit-icon icon-remove-sign" })
		})]
	});
});
//#endregion
export { p as DEFAULT_TYPE, m as SUPPORTED_TYPES, g as default };

//# sourceMappingURL=ClearableInput.js.map